import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import Grid from '../components/Grid'
import StripePageTitle from '../components/StripePageTitle'
import StripeTables from '../components/StripeTables'
import UbliqueContainer from '../components/Container'
import StripeKPIs from '../components/StripeKPIs'
import StripeActiveFilters from '../components/StripeActiveFilters'

import './index.scss'

const PageOutputKpisTables = ({
  title,
  className,
  stripeKpis,
  stripeKpisTitle,
  stripeKpisComponent,
  stripeTables,
  stripeActiveFilters,
  stripeModal = null,
  configMenu
}) => {
  return (
    <UbliqueContainer stripeModal={stripeModal}>
      <Grid className={cn('ublique-page-kpis-tables', className)}>
        {title && <StripePageTitle text={title} configMenu={configMenu} />}
        {stripeActiveFilters && (
          <StripeActiveFilters filterProps={stripeActiveFilters} />
        )}
        {stripeKpis && (
          <StripeKPIs
            kpis={stripeKpis}
            stripeKpisTitle={stripeKpisTitle}
            stripeKpisComponent={stripeKpisComponent}
          />
        )}
        {stripeTables && <StripeTables tables={stripeTables} />}
      </Grid>
    </UbliqueContainer>
  )
}

PageOutputKpisTables.propTypes = {
  // da sistemare con Yup
  title: PropTypes.string,
  className: PropTypes.string,
  stripeKpis: PropTypes.array,
  stripeTables: PropTypes.array,
  stripeModal: PropTypes.object,
  stripeActiveFilters: PropTypes.object
}

export default PageOutputKpisTables
